import React, { useEffect, useRef, useState } from 'react';
import { isWeb } from '../utils/webOnly';

// Transient pill shown whenever the app zoom changes (⌘/Ctrl +/- via the View
// menu, or the Settings control). Gives immediate feedback and quietly teaches
// that zoom is adjustable + remembered. Desktop only (no-op on web/mobile).
const ZoomIndicator = () => {
    const [percent, setPercent] = useState(null);
    const [visible, setVisible] = useState(false);
    const timerRef = useRef(null);

    useEffect(() => {
        if (isWeb || !window.electron?.zoom?.onChanged) return undefined;
        const off = window.electron.zoom.onChanged((p) => {
            setPercent(p);
            setVisible(true);
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => setVisible(false), 1200);
        });
        return () => { if (off) off(); clearTimeout(timerRef.current); };
    }, []);

    if (percent == null) return null;
    return (
        <div
            aria-hidden="true"
            style={{
                position: 'fixed',
                bottom: '88px',
                left: '50%',
                transform: `translateX(-50%) translateY(${visible ? '0' : '8px'})`,
                background: 'var(--color-bg-tertiary, #2b2f32)',
                color: 'var(--color-text-primary)',
                border: '1px solid var(--color-border)',
                borderRadius: '8px',
                padding: '6px 14px',
                fontSize: '13px',
                fontWeight: 600,
                fontVariantNumeric: 'tabular-nums',
                boxShadow: '0 6px 20px rgba(0, 0, 0, 0.45)',
                opacity: visible ? 1 : 0,
                pointerEvents: 'none',
                zIndex: 100000,
                transition: 'opacity 0.15s ease, transform 0.15s ease',
            }}
        >
            {percent}%
        </div>
    );
};

export default ZoomIndicator;
